export default "__VITE_ASSET__GN6zfbbi__"